module.exports = __webpack_public_path__ + "static/media/karachiUni.5e673cae.jpeg";